// @ts-strict-ignore
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { uniqueId } from 'lodash-es';
import { GlobalIcon, GlobalIconColour, GlobalIconSize } from '../icon/icon.constants';
import { InputBaseComponent } from '../input-base/input-base.component';
import { TooltipConfig } from '../tooltip/types';

@Component({
    selector: 'ui-input-number',
    templateUrl: './input-number.component.html',
    styleUrls: ['./input-number.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputNumberComponent extends InputBaseComponent<number> {
  @Input() footerMessage: string;
  @Input() max?: string;
  @Input() min?: string;
  @Input() name: string = uniqueId('number');
  @Input() placeholder: string = '';
  @Input() showArrows: boolean = true;
  @Input() step: string = null;
  @Input() suffix: string = null;
  @Input() tooltip?: TooltipConfig & { icon: GlobalIcon };

  @Output() blur: EventEmitter<number> = new EventEmitter();
  @Output() onFocus: EventEmitter<void> = new EventEmitter();

  readonly ICON_SIZE = GlobalIconSize.Medium;
  readonly ICON_COLOUR = GlobalIconColour.Grey;

  onBlur() {
    this._setValidValue();
    this._emit();
    this.blur.emit();
  }

  onFocusInput() {
    this.onFocus.emit();
  }

  onInputKeyDown($event: KeyboardEvent) {
    if ($event.key === 'Enter') {
      this._setValidValue();
      this._emit();
    }
  }

  private _emit() {
    this.onChange(+this.value);
    this.onTouched();
  }

  private _setValidValue() {
    const min = parseInt(this.min);
    const max = parseInt(this.max);
    if ((!!min || min === 0) && this.value < min) {
      this.value = min;
    }
    if ((!!max || min === 0) && this.value > max) {
      this.value = max;
    }
  }
}
